import { memo } from 'react';

import Stack from '@mui/material/Stack';
import ListSubheader from '@mui/material/ListSubheader';

import NavList from './nav-list';
import { NavProps, NavGroupProps } from '../types';

// ----------------------------------------------------------------------

function Group({ subheader, items, slotProps }: NavGroupProps) {
  const currentRole = slotProps?.currentRole || '';

  // ถ้า subheader มี roles และ currentRole ไม่ได้อยู่ใน roles ให้ return null
  if (subheader?.roles && !subheader.roles.includes(currentRole)) {
    return null;
  }

  // กรอง items ที่มี roles และ currentRole ไม่ได้อยู่ใน roles
  const filteredItems = items.filter((item) => {
    if (!item.roles) return true;
    return item.roles.includes(currentRole);
  });

  // ถ้าไม่มี items ที่แสดงได้ ให้ return null
  if (filteredItems.length === 0) {
    return null;
  }

  const renderContent = filteredItems.map((list) => (
    <NavList key={list.title} data={list} depth={1} slotProps={slotProps} />
  ));

  return (
    <Stack sx={{ px: 2 }}>
      {subheader ? (
        <>
          <ListSubheader
            disableGutters
            disableSticky
            sx={{
              fontSize: 11,
              cursor: 'pointer',
              typography: 'overline',
              display: 'inline-flex',
              color: 'text.disabled',
              mb: `${slotProps?.gap || 4}px`,
              p: (theme) => theme.spacing(2, 1, 1, 1.5),
              transition: (theme) =>
                theme.transitions.create(['color'], {
                  duration: theme.transitions.duration.shortest,
                }),
              '&:hover': {
                color: 'text.primary',
              },
              ...slotProps?.subheader,
            }}
          >
            {subheader.title}
          </ListSubheader>

          {renderContent}
        </>
      ) : (
        renderContent
      )}
    </Stack>
  );
}

function NavSection({ data, slotProps, ...other }: NavProps) {
  return (
    <Stack component="nav" id="nav-section-vertical" {...other}>
      {data.map((group, index) => (
        <Group
          key={group.subheader?.title || index}
          subheader={group.subheader}
          items={group.items}
          slotProps={slotProps}
        />
      ))}
    </Stack>
  );
}

export default memo(NavSection);
